<template lang="pug">
button.text-primary-text.gtm-function.bg-gradient-to-r.from-header-from.to-header-to.rounded-md.z-10.relative(class="aspect-[277/72] text-[16px]", type="button", @click.stop="click")
  .absolute.inset-0.rounded-md.overflow-hidden.pointer-events-none(v-if="isBirthdayToday")
    img.birthday-confetti.absolute.max-w-none(src="/common/confetti.svg", alt="", class="w-[500%] h-[500%] -top-[200%] -start-[200%]")
  .flex.items-center.gap-1.relative(class="py-[8px] px-[4px]")
    .flex.justify-center.items-center
      img.w-10(src="assets/images/common/coin_img_customize_normal.png", class="xl:w-8")
    .flex.flex-1.items-center.flex-col.text-custom.font-bold(class="gap-1 xl:gap-0")
      span.leading-4.truncate {{ $t('title.daily_tasks') }}
      .relative.w-full.h-4.rounded-full.overflow-hidden.flex.items-center.justify-center.from-header-field-from.to-header-field-to.bg-linear-to-b.border-header-field-border.border.border-header-field-board(class="xl:h-2")
        .absolute.rounded-full.overflow-hidden(class="inset-[1px]")
          span.progress.absolute.inset-y-0.left-0.rounded-full.block.bg-linear-to-b.from-vipcard-progress-1-from.to-vipcard-progress-1-to(:style="`width: ${overallProgress}%`")
        span.relative.leading-none.text-primary-text(class="text-[10px] xl:text-[12px]") {{ isNoData ? $t('common.no_data') : `${overallProgress}%` }}
</template>

<script setup>
import { computed } from 'vue'

import { useActivity } from '@/composables/activity/useActivity'
import { useMainStore } from '@/stores/main'

const mainStore = useMainStore()
const { setModal, setModalParams } = mainStore
const { progressSummary } = useActivity('menu-mission-progress')
const { isBirthdayToday } = useUserInfo()
const { $analytics } = useNuxtApp()

const isNoData = computed(() => {
  if (!progressSummary.value) return true
  const { totalActivities = 0 } = progressSummary.value
  return totalActivities === 0
})

const overallProgress = computed(() => {
  if (!progressSummary.value) return 0
  const { totalActivities = 0, completedActivities = 0, overallAchievementRate = 0 } = progressSummary.value

  // 如果有 overallAchievementRate 且大於 0，則優先使用
  if (overallAchievementRate > 0) return overallAchievementRate

  if (totalActivities === 0) return 0
  return Math.round((completedActivities / totalActivities) * 100)
})

const click = () => {
  $analytics.push({
    event: 'lobby_click',
    location: 'lobby',
    icon: 'MenuMissionProgress',
    component_name: 'MenuMissionProgress',
  })
  setModalParams({ id: 'progress' })
  setModal('ModalMission')
}
</script>

<style scoped>
@reference "@/assets/css/tailwind.css";
</style>
